import { brokerOutreachCopy } from "./brokerOutreachCopy";

/**
 * WSA — the locked listing-link line, shown where it goes out: after the message,
 * above the sign-off. Code inserts it from the listing's stored URL at every
 * preview, copy and send, so it is never part of the editable body; with no URL
 * that qualifies, the note says where to add one, and the email still goes.
 */
export function ListingLinkLine({ line, testId }: { line: string | null; testId: string }) {
  return (
    <div className="grid gap-space-2" data-testid={testId}>
      <span className="text-caption text-gray-mid uppercase tracking-wider">
        Listing link, added automatically
      </span>
      {line ? (
        <div className="rounded-md border border-border-light bg-white-warm px-space-3 py-space-2">
          <p className="text-small text-gray-mid break-all m-0" data-testid={`${testId}-line`}>
            {line}
          </p>
        </div>
      ) : (
        <p className="text-small text-gray-mid m-0" data-testid={`${testId}-missing`}>
          {brokerOutreachCopy.noListingLink}
        </p>
      )}
    </div>
  );
}
